import DocumentsForm from './DocumentsForm';

export default DocumentsForm;
